import { Box } from '@mui/material';
import { PeriodEnum } from 'common/defines/clients';
import { ILooseFruitData, IYieldSummary } from 'interfaces/erms';
import { FC } from 'react';
import LooseFruitComparisonSection from './LooseFruitComparisonSection';
import YieldComparisonSection from './YieldComparisonSection';

interface ComparisonSectionProps {
  yieldData: IYieldSummary[];
  hoverDatePoint: string;
  selectedPeriod: PeriodEnum;
  area: number;
  totalTree: number;
  looseFruitData: ILooseFruitData[];
}

const ComparisonSection: FC<ComparisonSectionProps> = ({
  yieldData,
  hoverDatePoint,
  selectedPeriod,
  area,
  totalTree,
  looseFruitData,
}) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(2, 1fr)"
      gridTemplateRows="repeat(5, 1fr)"
      gridAutoFlow={'column'}
      gap="8px">
      <YieldComparisonSection
        yieldData={yieldData}
        hoverDatePoint={hoverDatePoint}
        selectedPeriod={selectedPeriod}
        area={area}
        totalTree={totalTree}
      />
      <LooseFruitComparisonSection
        looseFruitData={looseFruitData}
        hoverDatePoint={hoverDatePoint}
        selectedPeriod={selectedPeriod}
        area={area}
        totalTree={totalTree}
      />
    </Box>
  );
};

export default ComparisonSection;
